import React from "react";

export function GeneralSettingsPlaceholder() {
  return (
    <div className="pal">
      <div className="notice">
      </div>
    </div>
  );
}
